// extracted by mini-css-extract-plugin
module.exports = {"privacyPageContainer":"Privacy_privacyPageContainer__1GkpJ","privacyPageSectionOne":"Privacy_privacyPageSectionOne__3HjXX","privacyPage":"Privacy_privacyPage__3CWjz"};